import React, { useContext } from 'react';
import './Step.css';
import { useTranslation } from 'react-i18next';
import LanguageContext from '../../../context/LanguageContext.js';

const stepsData = [
    { num: '01', key: 'step1', icon: (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="14" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M14 20L18 24L26 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        )},
    { num: '02', key: 'step2', icon: (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="10" y="12" width="20" height="16" rx="3" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M15 19H25M15 23H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
        )},
    { num: '03', key: 'step3', icon: (
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 10L22.9 17.3H30.6L24.4 21.9L26.9 29.5L20 24.6L13.1 29.5L15.6 21.9L9.4 17.3H17.1L20 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
            </svg>
        )},
];

const Steps = () => {
    const { dir } = useContext(LanguageContext);
    const { t } = useTranslation();

    return (
        <section className="steps-section" id="steps">
            <div className="container steps-container">

                <div className="steps-header">
                    <span className="steps-eyebrow">{t('steps.eyebrow')}</span>
                    <h2 className="steps-title">{t('steps.title')}</h2>
                    <div className="steps-title-line" />
                </div>

                <div className="steps-grid" dir={dir()}>
                    {stepsData.map(({ num, key, icon }, i) => (
                        <div className="steps-card" key={num} style={{ '--i': i }}>
                            <div className="steps-card-inner">
                                <div className="steps-card-top">
                                    <div className="steps-icon-wrap">
                                        {icon}
                                    </div>
                                    <span className="steps-num">{num}</span>
                                </div>
                                <div className="steps-card-body">
                                    <h3 className="steps-card-title">
                                        {t(`steps.${key}Title`)}
                                    </h3>
                                    <p className="steps-card-desc">
                                        {t(`steps.${key}Description`)}
                                    </p>
                                </div>
                                <div className="steps-card-footer">
                                    <span className="steps-tag">{t('steps.stepLabel', { num })}</span>
                                </div>
                            </div>
                            {i < stepsData.length - 1 && (
                                <div className="steps-connector" aria-hidden="true">
                                    <svg viewBox="0 0 60 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 6H54M54 6L48 1M54 6L48 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Steps;